import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Autoplay, FreeMode, Pagination } from "swiper";
import { useProductStore } from "src/_cores/_store/root-store";
import GalleryDialog from "../dialog/prod-gallery";
import { useState } from "react";

const ProductDetailRealImages = () => {
  const productStore = useProductStore();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  
  const handleClickOpenDialog = (index: number) => {
    const url = process.env.REACT_APP_IMAGE_URL + '/products/' + (productStore.productDetail?.userImagePaths[index] ?? '')
    setSelectedImage(url);
    setOpenDialog(true);
  };

  return (
    <div className="product__images-slider">
      <h1 className="detail-title mb-0">
        <strong>HÌNH ẢNH THỰC TẾ</strong>
      </h1>
      <hr className="mt-0" />
      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        freeMode={true}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, FreeMode, Pagination]}
        className="mySwiper cursor-grab"
      >
        {productStore.productDetail?.userImagePaths.map((_, index) => (
          <SwiperSlide key={_}>
            <div className="flex items-center md:h-[350px] h-[120px] w-full top-0 left-0">
              <img
                alt=""
                src={process.env.REACT_APP_IMAGE_URL + '/products/' + _}
                onClick={() => {
                  handleClickOpenDialog(index);
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <GalleryDialog
        selectedImage={selectedImage}
        openDialog={openDialog}
        handleClickCloseDialog={() => setOpenDialog(false)}
      />
    </div >
  );
};

export default ProductDetailRealImages;
